




































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Popover } from 'element-ui';
import { namespace } from 'vuex-class';
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {
    [Popover.name]: Popover
  }
})

/**
 * 稿件审批状态鼠标经过组件
 */
export default class AcgnPopoverDetail extends Vue {
  @Prop() private row: any;
  @CommGetter private attributeData: any; // 公共类型

  // 审批状态样式
  private getClassSta(status: any) {
    switch (status) {
      case 0:
        return 'color--success';
      case 1:
        return 'color--gray';
      case 2:
        return 'color--danger';
    }
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.other_type[3];
  }

  // 审批状态名称
  private getNameSta(status: any) {
    return this.statusName[status].name;
  }
}
